module.exports = __webpack_public_path__ + "img/cslogo.af69ab3e.svg";